const { CarouselElement } = window.BAO.Carousel

const INTERACTIVE_SELECTOR = 'summary, button, a, select, input, label'

/**
 * keen-slider carousel for the gift detail drawer. Slides contain interactive
 * content (native <details> accordions), so two things are handled that a plain
 * image carousel does not need:
 *
 *  1. pointerdown on an interactive control is stopped before it reaches the
 *     slider, so keen-slider does not treat the tap as the start of a drag and
 *     swallow the click.
 *  2. the carousel is re-measured whenever an accordion opens or closes, so the
 *     new slide height is not clipped.
 */
class GiftWithPurchaseCarousel extends CarouselElement {
  beforeInitialiseCarousel () {
    this.els.slider.element.classList.add('keen-slider')
    this.els.slide.elements.forEach(slide => {
      slide.classList.add('keen-slider__slide')
    })

    this.querySelectorAll(INTERACTIVE_SELECTOR).forEach(element => {
      element.addEventListener('pointerdown', event => event.stopPropagation())
    })
  }

  async connectedCallback () {
    await super.connectedCallback()

    // The <details> toggle event does not bubble, so listen in the capture phase.
    this.addEventListener(
      'toggle',
      () => {
        if (this.carousel) this.carousel.update()
      },
      true,
    )

    this.setupArrows()
  }

  // Fixed prev/next arrows drive keen and hide at each end.
  setupArrows () {
    const prev = this.els.prev?.element
    const next = this.els.next?.element
    if (prev == null && next == null) return

    prev?.addEventListener('click', () => this.carousel?.prev())
    next?.addEventListener('click', () => this.carousel?.next())

    const lastIndex = this.els.slide.elements.length - 1
    const update = index => {
      if (prev) prev.hidden = index === 0
      if (next) next.hidden = index === lastIndex
    }

    this.carousel?.on('slideChanged', slider => {
      update(slider.track.details.rel)
    })
  }

  /** @returns {KeenSliderOptions} */
  get options () {
    return {
      slides: { perView: 1 },
    }
  }
}

if (!customElements.get('gift-with-purchase-carousel')) {
  customElements.define('gift-with-purchase-carousel', GiftWithPurchaseCarousel)
}
